<template>
    <li>
        <Icon v-if="checked" :icon="icons.checked" color="success"/>
        <Icon v-else :icon="icons.unchecked" color="gray-300"/>
        <span v-if="text">{{ text }}</span>
        <slot/>
        <lazy-tooltip v-if="help" left :text="help" with-touch>
            <Icon x-small class="ml-4" color="gray-300" force-size :icon="icons.help"/>
        </lazy-tooltip>
    </li>
</template>

<script>
import ListItemMixin from "../ListItemMixin";
    import {mdiCheckboxBlankOutline, mdiCheckboxMarkedOutline} from "@mdi/js";
	import {checkIcon, helpIcon} from "../../../config";

    export default {
        name: "CheckListItem",

        mixins: [ListItemMixin],

        props: {
            checked: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                icons: {
                    checked: mdiCheckboxMarkedOutline,
                    unchecked: mdiCheckboxBlankOutline,
					check: checkIcon,
					help: helpIcon,
                }
            }
        }
    }
</script>